import React from "react";
import { useTranslation } from "react-i18next";
import { X } from "lucide-react";
import { ProductImagesSection } from "@/features/product-detail/sections/ProductImagesSection";
import { ProductInfoSection } from "@/features/product-detail/sections/ProductInfoSection";
import { useProductDetailModalStore } from "@/features/product-detail/store/product-detail-modal-store";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

export const ProductDetailModal: React.FC = () => {
  const { t } = useTranslation();
  const { isOpen, productId, closeModal } = useProductDetailModalStore();

  const handleClose = () => {
    closeModal();
    // Sadece modal kapat, go back yapma
  };

  if (!isOpen || !productId) return null;

  return (
    <Dialog open={isOpen} onOpenChange={handleClose}>
      <DialogContent
        className="max-w-5xl max-h-[90vh] overflow-hidden p-0 bg-bg-secondary flex flex-col"
        open={true}
      >
        {/* Header - Sticky */}
        <DialogHeader className="sticky top-0 z-10 flex flex-row items-center justify-between p-4 sm:p-6 lg:p-8 pb-3 sm:pb-4 lg:pb-6  bg-bg-secondary dark:bg-bg-secondary backdrop-blur-sm">
          <DialogTitle className="text-base sm:text-lg lg:text-xl font-semibold leading-tight sm:leading-[28px] lg:leading-[32px] text-text-primary dark:text-text-primary">
            {t("productDetail.title")}
          </DialogTitle>
          <button
            onClick={handleClose}
            className="text-text-tertiary hover:text-text-secondary dark:text-text-tertiary dark:hover:text-text-secondary transition-colors flex-shrink-0"
            aria-label={t("common.close")}
          >
            <X className="size-5 sm:size-6" />
          </button>
        </DialogHeader>

        {/* Content - Scrollable */}
        <div className="flex-1 overflow-y-auto overscroll-contain">
          <div className="grid lg:grid-cols-2 gap-4 sm:gap-5 lg:gap-6 px-4 sm:px-6 lg:px-8 pb-4 sm:pb-6 lg:pb-8 pt-4 sm:pt-5 lg:pt-6">
            {/* ✅ Zero Props - Self-contained sections */}
            <ProductImagesSection />
            <ProductInfoSection variant="modal" />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
